import { render, staticRenderFns } from "./AdvertiserAbout.vue?vue&type=template&id=3b28c648&"
import script from "./AdvertiserAbout.vue?vue&type=script&lang=ts&"
export * from "./AdvertiserAbout.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertiserAbout.vue?vue&type=style&index=0&id=3b28c648&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports